import { IsProd } from "@/constants/config";
import request from "@/utils/request";

const PATH_PREFIX = IsProd ? "/v1/" : "/vb/";

export interface ApiSetUserPreferenceParams {
  cards?: string[];
  programs?: string[];
  cabins?: string;
  percent_premium?: number;
  // 1: list, 2: table
  real_time_search_table_type?: number;
}

export const setUserPreference = (data: ApiSetUserPreferenceParams) => {
  return request.post<ApiSetUserPreferenceParams, { status: number }>(
    PATH_PREFIX + "user_set_preference",
    {
      ...data,
    }
  );
};

export interface ApiSendInviteParams {
  email: string;
}

export const sendInvitation = (data: ApiSendInviteParams) => {
  return request.post<ApiSendInviteParams, { status: number }>(
    PATH_PREFIX + "user_send_invitation",
    {
      ...data,
    }
  );
};

export interface ApiGetUserEmailData {
  data: {
    email_info_lst: Array<{
      name: string;
      description: string;
      key: string;
      value: boolean;
    }>;

    email: string;
  };
  status: number;
}

export const getUserEmail = (data?: string) => {
  return request.post<{ data: string }, ApiGetUserEmailData>(
    PATH_PREFIX + "user_email_preference",
    {
      data,
    }
  );
};

export interface ApiSetUserEmailParams {
  email_lists: {
    [key: string]: boolean;
  };
  data?: string;
}

export const setUserEmail = (data: ApiSetUserEmailParams) => {
  return request.post<ApiSetUserEmailParams, { status: number }>(
    PATH_PREFIX + "user_set_email_preference",
    {
      ...data,
    }
  );
};

export const getUserRefereeMap = () => {
  return request.post<
    unknown,
    {
      data: {
        created_at: string;
        referee_code: string;
        user_id: string;
      }[];
      status: number;
    }
  >(PATH_PREFIX + "user_referee_map", {});
};

export const getUserDailyLimit = () => {
  return request.post<
    unknown,
    {
      real_time_search_block: boolean;
      hard_real_time_search_block: boolean;
    }
  >(PATH_PREFIX + "user_daily_limit", {});
};
